/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Weekly
 * 
 * 1 = Monthly
 * 
 * 2 = Yearly
 */
export enum PaymentFrequency {
  Weekly = 0,
  Monthly = 1,
  Yearly = 2
}
